/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useEffect, useMemo, useState } from "react";
import { BEM } from "@adapptio/lib-components";
import { FLOATING_PANEL_ITEM_STATE, IFloatingPanelEntry } from "./FloatingPanelManager";
import { offEvent, onEvent } from "@adapptio/lib-shared";

export interface IFloatingPanelHostProps {
	entry?: IFloatingPanelEntry;
}

export const FloatingPanelHost: React.FC<IFloatingPanelHostProps> = ({ entry }) => {
	const [ state, setState ] = useState(entry.state);

	useEffect(() => {
		const handleStateChange = () => setState(entry.state);

		onEvent(entry.onStateChange, handleStateChange);

		return () => {
			offEvent(entry.onStateChange, handleStateChange);
		};
	}, [ entry ]);

	const floatingPanel = useMemo(
		() => ({
			component: entry.instance.getComponent()
		}),
		[ entry.instance ]
	);

	const baseClass = BEM("edt-floating-panel-host", null, {
		opened: state === FLOATING_PANEL_ITEM_STATE.OPENED
	});

	return (
		<div className={baseClass.toClassName()}>
			<floatingPanel.component floatingPanelModel={entry.instance} />
		</div>
	);
};
